import { render, staticRenderFns } from "./LayersToolSplit.vue?vue&type=template&id=40ce230a&scoped=true"
import script from "./LayersToolSplit.vue?vue&type=script&lang=js"
export * from "./LayersToolSplit.vue?vue&type=script&lang=js"
import style0 from "./LayersToolSplit.vue?vue&type=style&index=0&id=40ce230a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce230a",
  null
  
)

export default component.exports